import { useQuery } from "@tanstack/react-query";
import { programmeDashboardApi } from "../api/programmeDashboard";

export interface ActivityListFilters {
    category?: string[];
    owner?: string[];
    search_term?: string;
}

export const useFetchPortfolioActivityList = (portfolioId?: string, filters?: ActivityListFilters) => {
    const { data, isFetching, isSuccess, isPending, isError, error, refetch } = useQuery({
        queryKey: ["portfolio-activity-list", portfolioId, filters],
        queryFn: () => programmeDashboardApi.fetchPortfolioActivityList(portfolioId, filters),
        enabled: !!portfolioId,
    });

    return {
        data: isSuccess ? (data?.data?.rows ?? data?.rows ?? []) : [],
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };
};
